import React from 'react';
import { RouteComponentProps, generatePath } from 'react-router';

import { useFeatureSwitch } from '@xingternal/hub';

import { JobPostingContainer } from '@/components/job-posting';
import { routes } from '@/config';

type Props = RouteComponentProps<{ slug: string }>;

export const JobDetailPage: React.FC<Props> = ({ match }) => {
  const isJDPCrateEnabled = useFeatureSwitch('enable_jdp_crate');

  if (isJDPCrateEnabled) {
    // LI redirect
    if (typeof window !== 'undefined') {
      const cratePath = generatePath(routes.crateJobDetail, { slug: match.params.slug });
      window.location.replace(cratePath);
      return null;
    }
  }

  return <JobPostingContainer slug={match.params.slug} />;
};
